import React from "react";
import { alertVariants, type AlertVariant } from "@/lib/docs-theme";

interface DocAlertProps {
  variant?: AlertVariant;
  children: React.ReactNode;
  className?: string;
}

export default function DocAlert({ variant = "info", children, className = "" }: DocAlertProps) {
  return (
    <div className={`rounded-lg p-4 border ${alertVariants[variant]} ${className}`}>{children}</div>
  );
}
